import { api, apiAxiosInstance } from './api';
import { getParams } from 'utils';

export const fetchUserGroupsList = (query, options) => {
  const params = getParams(query);
  return api.get('/user_group', params, options);
};

export const fetchUserGroupsBusiness = (query) => {
  const params = getParams(query);
  return api.get('/user_group/business', params);
};

export const fetchUserGroupById = (id, params = {}) => {
  return api.get(`/user_group/${id}`, params);
};

export const fetchUserGroupBusinessById = (id, params = {}) => {
  return api.get(`/user_group/business/${id}`, params);
};

export const createUserGroup = (payload) => {
  return api.post('/user_group', payload);
};

export const updateUserGroup = (id, payload) => {
  return api.put(`/user_group/${id}`, payload);
};

export const createUserGroupBusiness = (payload) => {
  return api.post('/user_group/business', payload);
};

export const updateUserGroupBusiness = (id, payload) => {
  return api.put(`/user_group/business/${id}`, payload);
};

export const deleteUserGroup = (id) => {
  return api.delete(`/user_group/${id}`);
};

export const fetchParents = (id, payload) => {
  return api.get(`/user_group/${id}/parent`, payload);
};

export const fetchAddParetToUserGroup = (id, payload) => {
  return api.put(`/user_group/${id}/parent`, payload);
};

export const fetchRemoveParetFromUserGroup = (id, payload) => {
  return apiAxiosInstance
    .delete(`/user_group/${id}/parent`, {
      data: payload,
    })
    .catch((err) => {
      return err.response;
    });
};

export const fetchInviteUser = (id, payload) => {
  return api.post(`/user_group/${id}/invite`, payload);
};
